// `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="lucide lucide-pool-sb">
// <circle cx="12" cy="12" r="10"/>
// <path d="M10,7H14L17,11H7ZM15,11V17H9V11"/>
// </svg>`

import { LucideIconData } from 'lucide-angular';

export const PoolSmallBusiness: LucideIconData = [
  [
    'circle',
    {
      cx: '12',
      cy: '12',
      r: '10',
    },
  ],
  [
    'path',
    {
      d: 'M10,7H14L17,11H7ZM15,11V17H9V11',
    },
  ],
];
